import React, {memo, ReactNode} from 'react';
import './index.scss';
import { useChangeTheme } from '../../hooks/change-theme';

type Props = {
    locked: boolean;
    children?: ReactNode;
};

export const Sidebar = memo(function Sidebar({locked, children}: Props) {
    const {theme} = useChangeTheme()
    return (
        <div
            className={`device-list-wrapper ${theme === 'rounded' ? 'device-list-wrapper-options' : ''} visible` + (locked ? ' blur' : '')}>
            <div className="device-list">
                {children}
            </div>
        </div>
    );
});
